// extracted by mini-css-extract-plugin
module.exports = {"OASIS-2-us":"OASIS2_OASIS-2-us__bodU6"};